import { jsxAsElement as jsx } from 'web-shared/src/lib/jsx';
import { TypedAttributes, TypedElement } from '../htmlElementTyped';

export interface SkeletonAttributes extends TypedAttributes {
  width: string;
  height: string;
  margin?: string;
}

export class Skeleton extends TypedElement<SkeletonAttributes> {
  constructor() {
    super();
  }

  render = async () => {
    const { width, height, margin } = this.typedAttributes;

    if (width && height) {
      this.innerHTML = '';
      this.append(
        <div
          style={`--width: ${width}; --height: ${height}; --margin: ${margin || '0'};`}
          className="skeleton"
        />,
      );
    }
  };

  connectedCallback() {
    void this.render();
  }
}
